import { useEffect, useMemo, useRef, useState } from 'react';
var defaultState = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
};
/**
 * Subscribe to element size and position changes with ResizeObserver. Returns [ref, rect].
 * Source: https://mantine.dev/hooks/use-resize-observer/
 */
export function useResizeObserver() {
    var browser = typeof window !== 'undefined';
    var frameID = useRef(0);
    var ref = useRef(null);
    var _a = useState(defaultState), rect = _a[0], setRect = _a[1];
    var observer = useMemo(function () {
        return browser
            ? new ResizeObserver(function (entries) {
                var entry = entries[0];
                if (entry) {
                    cancelAnimationFrame(frameID.current);
                    frameID.current = requestAnimationFrame(function () {
                        if (ref.current) {
                            setRect(entry.contentRect);
                        }
                    });
                }
            })
            : null;
    }, []);
    useEffect(function () {
        if (ref.current) {
            observer === null || observer === void 0 ? void 0 : observer.observe(ref.current);
        }
        return function () {
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
            if (frameID.current) {
                cancelAnimationFrame(frameID.current);
            }
        };
    }, [ref.current]);
    return [ref, rect];
}
